var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-content-loading',{attrs:{"width":300,"height":100}},[_c('rect',{attrs:{"x":"255","y":"0","rx":"1","ry":"1","width":"15%","height":"10%"}}),_vm._v(" "),_c('rect',{attrs:{"x":"0","y":"13","rx":"0","ry":"0","width":"100%","height":"90%"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c6c2512","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/skeleton-loading/jLoadingTable.vue
// module id = null
// module chunks = 